import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import { fromJS } from 'immutable'
import { actions } from 'react-redux-form/immutable'
import Panel from 'react-bootstrap/lib/Panel'

import Loading from 'components/Loading'
import Content from 'containers/Enrolment/content'
import { fetchSubjects, fetchOfferings } from 'containers/Enrolment/actions'
import NotAdvised from 'containers/Enrolment/not-advised'

import FormContainer from './form-container'

const AddWithdraw = ({ __advising, __advisingHasFetched, __sy, __sem }) => {
  if (!__advisingHasFetched) {
    return <Loading />
  }

  let content = null

  if (__advising.size === 0) {
    content = <NotAdvised />
  } else {
    content = Content('add-withdraw', __advising.get('semcamp_open'), __advising.get('is_registered'), __advising.get('has_applied'), __advising.get('is_open'))

    if (!content) {
      content = <FormContainer />
    }
  }

  const header = (
    <div className="row">
      <div className="col-sm-6">Add/Withdraw Subjects</div>
      <div className="col-sm-6 text-right">School Year: <strong className="text-primary">{__sy}</strong> Term: <strong className="text-primary">{__sem}</strong></div>
    </div>
  )

  return (
    <Panel header={header}>
      {content}
    </Panel>
  )
}

AddWithdraw.onEnter = (store) => () => {
  store.dispatch(fetchSubjects())
    .then((res) => {
      if (res && !res.error) {
        store.dispatch(actions.change('enrolledState', fromJS(res.payload)))
      }
    })
  store.dispatch(fetchOfferings())
    .then((res) => {
      if (res && !res.error) {
        store.dispatch(actions.change('offeringState', fromJS(res.payload)))
      }
    })
}

AddWithdraw.propTypes = {
  __advising: PropTypes.object,
  __advisingHasFetched: PropTypes.bool,
  __sy: PropTypes.string,
  __sem: PropTypes.string,
}

function mapStateToProps(state) {
  return {
    __advising: state.advisingState,
    __advisingHasFetched: state.enrolment.get('advisingHasFetched'),
    __sy: state.auth.getIn(['session', 'sy']),
    __sem: state.auth.getIn(['session', 'sem']),
  }
}

export default connect(mapStateToProps)(AddWithdraw)



// WEBPACK FOOTER //
// ./src/containers/Enrolment/AddWithdraw/index.js